import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { ScheduleFFHelpers, useCalendarEventsFormTypeShallowStore } from '@frontend/schedule-helpers';
import { customContextFactory } from '../hooks';
import { RenderAppointmentInfoTabContent } from '../types';
import { CalendarEventsContainer } from './Calendar/EventsPanel/CalendarEvents/CalendarEventsContainer';
import { CalendarEventsEnums } from './Calendar/types';
import { ScheduleAppointmentInfoPanel } from './schedule-appointment-info-panel';

interface Props {
  renderApptInfoPanelContent: RenderAppointmentInfoTabContent;
}

// SP-TODO: This context need to be removed once we move this panel to widget lib so we can directly use contact-panel component
export type TempApptInfoPanelContext = {
  renderApptInfoPanelContent: RenderAppointmentInfoTabContent;
};

const [TempApptInfoPanelContextProvider, useTempApptInfoPanelContext] =
  customContextFactory<TempApptInfoPanelContext>();

export { useTempApptInfoPanelContext };

export const ScheduleSidePanels = ({ renderApptInfoPanelContent }: Props) => {
  const { isEnabled: isApptPanelFFEnabled } = ScheduleFFHelpers.useNewApptPanelFeatureFlag();
  const { setSelectedForm } = useCalendarEventsFormTypeShallowStore('setSelectedForm');

  SchedulerV3.useScheduleCustomEventListener('schedule:new-appointment', () => {
    setSelectedForm(CalendarEventsEnums.APPOINTMENT_EVENT);
  });

  return (
    <>
      <CalendarEventsContainer />
      {isApptPanelFFEnabled && (
        <TempApptInfoPanelContextProvider value={{ renderApptInfoPanelContent }}>
          <ScheduleAppointmentInfoPanel />
        </TempApptInfoPanelContextProvider>
      )}
    </>
  );
};
